// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__197rs","content":"styles_content__2dVti"};